import { baseEnvironment } from './environment.base';

export const environment = {
  ...baseEnvironment,
  production: true,
  websocket: `ws://${ window.location.host }/api/subscriptions`,
  breakAtGraphqlErrors: false,
};
